import React, { useRef, useState, useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
    CButton,
    CCard,
    CCardBody,
    CCardGroup,
    CCol,
    CContainer,
    CForm,
    CInput,
    CInputGroup,
    CInputGroupPrepend,
    CInputGroupText,
    CRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CFormGroup,
    CLabel,
    CModalFooter,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { users } from "../../assets/data/users.js";
import { useHistory } from "react-router-dom";
import ApiUser from "../../api/ApiUser.js";
import Swal from "sweetalert2";
import { setLocalStorage } from "../../utils/localStorage.js";
import { isMobile, isTablet } from "react-device-detect";
import { useWindowSize } from "../../utils/WindowSize.js";
import { StaticImage } from "../../utils/image.js";
import CSwl from "../../utils/alert.js";
const logoDGA = require("./../../assets/icons/law-beta_version-02_20210507.svg");
const logoDigital = require("./../../assets/icons/digital-id-resize.svg");
const LoginSuccess = () => {
    const [width, height] = useWindowSize();
    const history = useHistory();
    const [userOpenId, setuserOpenId] = useState({});
    const formInput = useRef(null);
    const [error, seterror] = useState();
    const [errorToken, setErrorToken] = useState();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [token, setToken] = useState("");
    const [modalToken, setModalToken] = useState(false);

    const toggleToken = () => {
        setToken("");
        setModalToken(!modalToken);
    };
    // ใช้ useLocation เพื่อดึง URL ปัจจุบัน

    const location = useLocation();
    const dispatch = useDispatch();
    const userState = useSelector((state) => state.user);


    // ฟังก์ชันสำหรับแยก query parameters
    const getQueryParams = (search) => {
        const params = new URLSearchParams(search);
        return {
            code: params.get('code'),
            scope: params.get('scope'),
            sessionState: params.get('session_state'),
        };
    };



    useEffect(() => {
        // ดึงค่าจาก URL
        login();
    }, []);

    const login = async () => {
        try {
            const { code, scope, sessionState } = getQueryParams(location.search);
            Swal.showLoading();
            const result = await ApiUser.loginV2({
                code: code
            });
            if (result.status == 200) {
                const { user, token, isRequestToken } = result.data;

                Swal.close();
                if (isRequestToken) {
                    toggleToken();
                    setuserOpenId(user);
                } else {
                    dispatch({ type: "set_user", user: user, token: token });

                    setLocalStorage("tokenBackoffice", token);
                    if (user.role == "WebboardAdmin") {
                        history.push("/home/webboardbyproject");
                    }
                    else if (user.role == "LawEditor" || user.role == 'LawAdmin') {
                        history.push("/home/tableoflaw");
                    } else {
                        history.push("/home/listening");
                    }
                }
            }
            Swal.close();
        } catch (error) {
            const { data, status } = error.response;
            await CSwl.SwalErr(data.message);
            history.push("/");
        }
    }

    const onSubmitToken = (e) => {
        e.preventDefault();
        const model = {
            ...userOpenId,
            // username: username,
            // password: password,
            token: token,
        };

        submitToken(model);
        // saveData(model);
    };

    const submitToken = async (data) => {
        try {
            Swal.showLoading();
            const result = await ApiUser.submitTokenV2(data);
            if (result.status == 200) {
                const { user, token } = result.data;
                Swal.close();
                dispatch({ type: "set_user", user: user, token: token });
                setLocalStorage("tokenBackoffice", token);
                history.push("/home/listening");
            }
            //   toggle();
            //   setSelected([]);
            //   refreshData();
        } catch (error) {
            Swal.close();
            const { data } = error.response;
            setErrorToken(data?.message);
        }
    };

    React.useEffect(() => {
        if (width > 0) {
            if (width < 600) {
                Swal.fire({
                    title: "",
                    text: "ไม่สามารถรองรับหน้าจอที่เล็กเกินไป ทำให้มีผลต่อประสิทธิภาพการใช้งานของคุณ",
                    icon: "info",
                });
            } else if (width < 960) {
                Swal.fire({
                    title: "",
                    text: "การใช้งานด้วยขนาดหน้าจอนี้ อาจจะมีผลต่อการแสดงผลเล็กน้อย",
                    icon: "info",
                });
            }
        }
        return () => { };
    }, [width]);

    useEffect(() => {
        if (document.getElementById("tailwind-js")) {

        } else {
            const script = document.createElement("script");
            script.src = `${StaticImage("/tailwind.js")}`;
            script.id = "tailwind-js";
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return (
        <div className="c-app c-default-layout bg-dark flex-row align-items-center">
            <CModal show={modalToken} onClose={setModalToken}>
                <CModalHeader closeButton>
                    <CModalTitle>Token</CModalTitle>
                </CModalHeader>
                <CForm onSubmit={onSubmitToken}>
                    <CModalBody>
                        <CRow>
                            <CCol xs="12">
                                <CFormGroup>
                                    <CLabel htmlFor="token">Token</CLabel>
                                    <CInput
                                        custom
                                        name="token"
                                        id="token"
                                        onChange={(e) => setToken(e.target.value)}
                                    />
                                </CFormGroup>
                            </CCol>
                        </CRow>
                        <label className="text-danger mt-3">{errorToken}</label>
                    </CModalBody>
                    <CModalFooter>
                        <CButton type="submit" color="success">
                            ยืนยัน
                        </CButton>{" "}
                        <CButton color="secondary" onClick={() => {
                            setModalToken(false);
                            history.push('/');
                        }}>
                            ยกเลิก
                        </CButton>
                    </CModalFooter>
                </CForm>
            </CModal>
        </div>
    );
};

export default LoginSuccess;
